import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "react-feather";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styles from "./vehicledetail.module.css";

// Vehicle photos ([{ url, thumb }]): main image with arrows and counter, thumbnails, click to enlarge. Photos are never labelled.
const PhotoCarousel = ({ photos, fromTenant = false }) => {
  const list = photos || [];
  const [index, setIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    if (index > 0 && index >= list.length) setIndex(0);
  }, [index, list.length]);

  if (list.length === 0) {
    return (<div className={styles.Carousel}>
      <div className={`${styles.CarouselMain} ${styles.CarouselEmpty}`}>
        <img src="/static/img/car.svg" alt="" className={styles.CarouselPlaceholder} />
      </div>
      <p className={styles.CarouselCaption}>No photos</p>
    </div>);
  }

  const current = list[Math.min(index, list.length - 1)];
  const go = (step) => setIndex((prev) => (prev + step + list.length) % list.length);

  return (<div className={styles.Carousel}>
    <div className={styles.CarouselMain}>
      <img src={current.url} alt={`Vehicle photo ${index + 1}`} onClick={() => setLightboxOpen(true)} />
      <span className={styles.CarouselCounter}>{index + 1}/{list.length}</span>
      {list.length > 1 && (<>
        <button type="button" aria-label="Previous photo" className={`${styles.CarouselArrow} ${styles.CarouselPrev}`} onClick={(e) => { e.stopPropagation(); go(-1); }}><ChevronLeft size={16} /></button>
        <button type="button" aria-label="Next photo" className={`${styles.CarouselArrow} ${styles.CarouselNext}`} onClick={(e) => { e.stopPropagation(); go(1); }}><ChevronRight size={16} /></button>
      </>)}
    </div>

    {list.length > 1 && (<div className={styles.CarouselThumbs}>
      {list.map((photo, i) => (<button
        type="button"
        key={(photo.id ?? photo.url) + "-" + i}
        aria-label={`Show photo ${i + 1}`}
        className={i === index ? `${styles.CarouselThumb} ${styles.CarouselThumbOn}` : styles.CarouselThumb}
        onClick={(e) => { e.stopPropagation(); setIndex(i); }}
      >
        <img src={photo.url} alt={`Vehicle photo ${i + 1}`} />
      </button>))}
    </div>)}

    <p className={styles.CarouselCaption}>
      {list.length} photo{list.length > 1 ? "s" : ""}{fromTenant ? " from tenant" : ""} · click to enlarge
    </p>

    <Lightbox
      open={lightboxOpen}
      close={() => setLightboxOpen(false)}
      index={index}
      on={{ view: ({ index: viewIndex }) => setIndex(viewIndex) }}
      carousel={{ finite: list.length <= 1, imageFit: "contain" }}
      slides={list.map((photo) => ({ src: photo.url }))}
    />
  </div>);
};

export default PhotoCarousel;
